import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import Dashboard from "../views/pages/Dashboard";
import NotFoundPage from "../views/pages/NotFoundPage";
import BlogsPage from "../views/pages/blogs/BlogsPage";
import CreateBlogsPage from "../views/pages/blogs/CreateBlog";
import { ToastContainer } from "react-toastify";
import NewslettersPage from "../views/pages/Newsletters/NewslettersPage";
import CreateNewsletterPage from "../views/pages/Newsletters/CreateNewsletter";
import GalleryPage from "../views/pages/gallery/index";
import UploadImagePage from "../views/pages/gallery/uploadImage";
import JobsPage from "../views/pages/Jobs/JobsPage";
import CreateJobPage from "../views/pages/Jobs/CreateJobPage";
import ReportsPage from "../views/pages/Reports/ReportsPage";
import CreateReportPage from "../views/pages/Reports/CreateReportPage";
import UsersPage from "../views/pages/users/UsersPage";
import UploadVideoPage from "../views/pages/gallery/uploadVideo";
import CreateUserPage from "../views/pages/users/CreateUser";
import PartnersPage from "../views/pages/partners/PartnersPage";
import CreatePartnerPage from "../views/pages/partners/CreatePartnerPage";
import MetricsPage from "../views/pages/metrics/MetricsPage";
import ContactPage from "../views/pages/contacts/ContactsPage";
import SubscribersPage from "../views/pages/subscriptions/Subscribers";
import ProductsPage from "../views/pages/products/ProductsPage";
import CreateProductsPage from "../views/pages/products/CreateProduct";
import FaqsPage from "../views/pages/faqs/FaqsPage";

const AppRoute = () => {
	return (
		<BrowserRouter>
			<div className="app">
				<ToastContainer />
				<Routes>
					<Route element={<DashboardLayout />}>
						<Route index element={<Dashboard />} />
						<Route path="/blogs-stories" element={<BlogsPage />} />
						<Route path="/blogs-stories/new" element={<CreateBlogsPage />} />
						<Route path="/blogs-stories/:id" element={<BlogsPage />} />
						<Route
							path="/blogs-stories/:id/edit"
							element={<CreateBlogsPage />}
						/>
						<Route path="/newsletters" element={<NewslettersPage />} />
						<Route path="/newsletters/new" element={<CreateNewsletterPage />} />
						<Route path="/newsletters/:id" element={<NewslettersPage />} />
						<Route
							path="/newsletters/:id/edit"
							element={<CreateNewsletterPage />}
						/>
						<Route path="/gallery" element={<GalleryPage />} />
						<Route path="/gallery/photos/new" element={<UploadImagePage />} />
						<Route
							path="/gallery/photos/:id/edit"
							element={<UploadImagePage />}
						/>
						<Route path="/gallery/videos/new" element={<UploadVideoPage />} />
						<Route
							path="/gallery/videos/:id/edit"
							element={<UploadVideoPage />}
						/>

						<Route path="/jobs" element={<JobsPage />} />
						<Route path="/jobs/new" element={<CreateJobPage />} />
						<Route path="/jobs/:id" element={<JobsPage />} />
						<Route path="/jobs/:id/edit" element={<CreateJobPage />} />

						<Route path="/reports" element={<ReportsPage />} />
						<Route path="/reports/new" element={<CreateReportPage />} />
						<Route path="/reports/:id" element={<ReportsPage />} />
						<Route path="/reports/:id/edit" element={<CreateReportPage />} />
						<Route path="/users" element={<UsersPage />} />
						<Route path="/users/new" element={<CreateUserPage />} />
						<Route path="/users/:id" element={<UsersPage />} />
						<Route path="/users/:id/edit" element={<CreateUserPage />} />

						<Route path="/partners" element={<PartnersPage />} />
						<Route path="/partners/new" element={<CreatePartnerPage />} />
						<Route path="/partners/:id" element={<PartnersPage />} />
						<Route path="/partners/:id/edit" element={<CreatePartnerPage />} />

						<Route path="/metrics" element={<MetricsPage />} />

						<Route path="/faqs" element={<FaqsPage />} />

						<Route path="/messages" element={<ContactPage />} />
						<Route path="/messages/:id" element={<ContactPage />} />
						<Route path="/subscribers" element={<SubscribersPage />} />

						<Route path="/products" element={<ProductsPage />} />
						<Route path="/products/new" element={<CreateProductsPage />} />
						<Route path="/products/:id" element={<ProductsPage />} />
						<Route path="/products/:id/edit" element={<CreateProductsPage />} />
					</Route>
					<Route path="*" element={<NotFoundPage />} />
				</Routes>
			</div>
		</BrowserRouter>
	);
};

export default AppRoute;
